<!-- FIREBASE V9 -->
<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        
        <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>
        <v-card-title>
            <v-btn icon @click="$router.go(-1)">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ title }}
            <v-spacer></v-spacer>
        </v-card-title>

        <!-- Dialog for confirm update user -->
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="text">Done!</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="goToQuizList">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-form ref="form" lazy-validation v-model="valid" class="ma-5 pa-5">
            <v-layout wrap="true">
                <v-flex xs12 md1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg-text text-md-right mr-md-3">No</p>
                </v-flex>
                <v-flex xs12 md1 class="d-md-none">
                    <p class="text-subtitle-1 text-md-right mr-md-3">No</p>
                </v-flex>
                <v-flex xs12 md1>
                    <v-text-field outlined :rules="requiredRule" v-model="editedItem.no" prepend="prefix test"></v-text-field>
                </v-flex>
            </v-layout>

            <br />
            <v-layout wrap="true">
                <v-flex xs12 md1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">คำถาม</p>
                </v-flex>
                <v-flex xs12 md1 class="d-md-none">
                    <p class="text-subtitle-1 text-md-right mr-md-3">คำถาม</p>
                </v-flex>
                <v-flex xs12 md7>
                    <v-textarea outlined :rules="requiredRule" v-model="editedItem.question" class="d-flex xs12 md7">
                    </v-textarea>
                </v-flex>
            </v-layout>

            <v-layout wrap="true">
                <v-flex xs12 md1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg-text text-md-right mr-md-3">A</p>
                </v-flex>
                <v-flex xs12 md1 class="d-md-none">
                    <p class="text-subtitle-1 text-md-right mr-md-3">A</p>
                </v-flex>
                <v-flex xs12 md7>
                    <v-text-field outlined :rules="requiredRule" v-model="editedItem.A">
                    </v-text-field>
                </v-flex>
            </v-layout>

            <v-layout wrap="true">
                <v-flex xs12 md1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg-text text-md-right mr-md-3">B</p>
                </v-flex>
                <v-flex xs12 md1 class="d-md-none">
                    <p class="text-subtitle-1 text-md-right mr-md-3">B</p>
                </v-flex>
                <v-flex xs12 md7>
                    <v-text-field outlined :rules="requiredRule" v-model="editedItem.B">
                    </v-text-field>
                </v-flex>
            </v-layout>

            <v-layout wrap="true">
                <v-flex xs12 md1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg-text text-md-right mr-md-3">C</p>
                </v-flex>
                <v-flex xs12 md1 class="d-md-none">
                    <p class="text-subtitle-1 text-md-right mr-md-3">C</p>
                </v-flex>
                <v-flex xs12 md7>
                    <v-text-field outlined :rules="requiredRule" v-model="editedItem.C">
                    </v-text-field>
                </v-flex>
            </v-layout>

            <v-layout wrap="true">
                <v-flex xs12 md1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg-text text-md-right mr-md-3">D</p>
                </v-flex>
                <v-flex xs12 md1 class="d-md-none">
                    <p class="text-subtitle-1 text-md-right mr-md-3">D</p>
                </v-flex>
                <v-flex xs12 md7>
                    <v-text-field outlined :rules="requiredRule" v-model="editedItem.D">
                    </v-text-field>
                </v-flex>
            </v-layout>

            <br />
            <v-layout wrap="true">
                <v-flex xs12 md1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg-text text-md-right mr-md-3">เฉลย</p>
                </v-flex>
                <v-flex xs12 md1 class="d-md-none">
                    <p class="text-subtitle-1 text-md-right mr-md-3">เฉลย</p>
                </v-flex>
                <v-flex xs12 md1>
                    <v-select :items="this.itemsAnswer" outlined :rules="requiredRule" v-model="editedItem.answer"></v-select>
                </v-flex>
            </v-layout>

            <v-layout wrap="true">
                <v-flex xs12 md1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">คำอธิบาย</p>
                </v-flex>
                <v-flex xs12 md1 class="d-md-none">
                    <p class="text-subtitle-1 text-md-right mr-md-3">คำอธิบาย</p>
                </v-flex>
                <v-flex xs12 md7>
                    <v-textarea outlined :rules="requiredRule" v-model="editedItem.answerDesc"></v-textarea>
                </v-flex>
            </v-layout>

            <v-layout wrap="true">
                <v-flex xs12 md1 class="d-none d-md-inline">
                    <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">อ้างอิง</p>
                </v-flex>
                <v-flex xs12 md1 class="d-md-none">
                    <p class="text-subtitle-1 text-md-right mr-md-3">อ้างอิง</p>
                </v-flex>
                <v-flex xs12 md7>
                    <v-textarea outlined :rules="refRule" v-model="editedItem.ref"></v-textarea>
                </v-flex>
            </v-layout>

            <br />
            <v-layout wrap="true">
                <v-flex xs12 md8 text-right>
                    <v-btn d-flex color="blue darken-1" text @click="goToQuizList"> Cancel </v-btn>
                    <v-btn v-if="this.id" color="blue darken-1" text @click="submit">
                        Update
                    </v-btn>
                    <v-btn v-else color="blue darken-1" text @click="submit">
                        Add
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import getQuizList from '../data/getQuizList';
import setQuizInfo from '../data/setQuizInfo';
export default {
    name: 'QuizManagementForm',
    metaInfo: {
        title: 'Quiz Management Form'
    },
    data() {
        return {
            editedItem: {
                no: "",
                question: "",
                A: "",
                B: "",
                C: "",
                D: "",
                answer: "",
                answerDesc: "",
                ref: ""
            },
            defaultItem: {
                no: "",
                question: "",
                A: "",
                B: "",
                C: "",
                D: "",
                answer: "",
                answerDesc: "",
                ref: ""
            },
            menu1: false,
            menu2: false,
            //to validate from
            valid: false,
            requiredRule: [
                (value) => !!value || "Required."
            ],
            refRule: [
                (value) => !!value || "Required.",
                (value) => this.isURL(value) || "URL is not valid",
            ],
            dialog: false,
            title: "Add new Quiz",
            itemsAnswer: ['A', 'B', 'C', 'D'],
            loading: false
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Quiz";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        this.id = this.$route.params.id;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessQuiz"
        ]),
        computedDateFormattedStartDate() {
            return this.formatDate(this.editedItem.startDate);
        },
        computedDateFormattedEndDate() {
            return this.formatDate(this.editedItem.endDate);
        },
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isAccessQuiz) {
                (async () => {
                    if (this.id) {
                        this.title = 'Edit Quiz';
                        this.editedItem = await getQuizList(this.id);
                    }
                    else{
                        //get max number
                        const quizList = await getQuizList();
                        this.editedItem.no = Math.max.apply(Math, quizList.map(function(o) { return o.no; })) + 1;
                    }
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        isURL(str) {
            let url;

            try {
                url = new URL(str);
            } catch (_) {
                return false;
            }

            return url.protocol === "http:" || url.protocol === "https:";
        },
        submit() {
            (async () => {
                //to validate from before submit
                await this.$refs.form.validate();

                if (this.valid) {
                    (async () => {
                        if (this.id) {
                            this.editedItem.updatedDate = new Date();
                            this.editedItem.updatedBy = this.loggedInUserId;
                            await setQuizInfo(this.editedItem, this.id);
                        } else {
                            this.editedItem.createdDate = new Date();
                            this.editedItem.createdBy = this.loggedInUserId;
                            this.editedItem.updatedDate = new Date();
                            this.editedItem.updatedBy = this.loggedInUserId;
                            await setQuizInfo(this.editedItem);
                        }

                        this.dialog = true;
                    })();
                }
            })();
        },
        close() {
            this.dialog = false;
        },
        goToQuizList() {
            this.$router.push(`/quiz`);
        }
    },
};
</script>

<style>
.v-textarea textarea {
    height: 70px;
}
p{
    margin-bottom: 0!important;
}
p.bg2-text{
    line-height: 47px!important;
    text-align: right;
}
p.bg-text{
    line-height: 55px!important;
    text-align: right;
}
</style>
